import * as React from "react"

export const MOBILE_BREAKPOINT = 768

/** Mirrors `(max-width: ${MOBILE_BREAKPOINT - 1}px)` — true when viewport width is mobile. */
export function isMobileWidth(width: number): boolean {
  return width <= MOBILE_BREAKPOINT - 1
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
  })

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
